import { render, staticRenderFns } from "./listado.vue?vue&type=template&id=f4bcffbc&scoped=true"
import script from "./listado.vue?vue&type=script&lang=js"
export * from "./listado.vue?vue&type=script&lang=js"
import style0 from "./listado.vue?vue&type=style&index=0&id=f4bcffbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bcffbc",
  null
  
)

export default component.exports